import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "components/form/Select/SimpleSelect";

interface PooledInstancesSelectProps {
    value: string | null | undefined;
    onChange(newValue: string | null): void;
}

const items: SimpleSelectItem[] = [
    {value: "", text: ""},
    {value: "true", text: "Yes"},
    {value: "false", text: "No"},
];

const PooledInstancesSelect: React.FC<PooledInstancesSelectProps> = props => (
    <SimpleSelect
        label="Pooled Instances"
        value={props.value === null || props.value === undefined ? "" : props.value}
        onChange={v => props.onChange(v === "" ? null : v)}
        items={items}
    />
);

export default PooledInstancesSelect;
